import { render, staticRenderFns } from "./EmpzoneColContentList.vue?vue&type=template&id=64d67bac&scoped=true&"
import script from "./EmpzoneColContentList.vue?vue&type=script&lang=js&"
export * from "./EmpzoneColContentList.vue?vue&type=script&lang=js&"
import style0 from "./EmpzoneColContentList.vue?vue&type=style&index=0&id=64d67bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d67bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d67bac')) {
      api.createRecord('64d67bac', component.options)
    } else {
      api.reload('64d67bac', component.options)
    }
    module.hot.accept("./EmpzoneColContentList.vue?vue&type=template&id=64d67bac&scoped=true&", function () {
      api.rerender('64d67bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/empzone/colContent/EmpzoneColContentList.vue"
export default component.exports